import { adjustEnding, formatCardKey, removeTrailingDot } from '@/ai/utils/helpers'

export const getCardTypeInstruction = (cardType, prefix) => {
  if (!cardType.generateWithAI) {
    return ''
  }

  return `${prefix || ''} ${adjustEnding(cardType.title, 1)}: ${removeTrailingDot(cardType.description)} (as ${formatCardKey(cardType.title)}). `
}

export const readModelNotes = [
  'Include the id of the entity being queried, preferably named only id and not <entityName>Id',
  'Exclude backticks when generating the JSON output',
  `The Read Model is a query that provides a view of the system state BEFORE the actor invokes the
   state-changing command. For example, if the command is "CreateProduct" and the entity
   is "Product", the id does not exist at this point in time and cannot be included in
   the query unless it is picked up from another system`,
  `The Read Model is a query that gives the actor background information necessary to make decisions,
   fill in the input form and submit it to invoke the command on the aggregate`
]
